<style scoped>
    .stock-calculator{
        position: relative;
    }
    .ivu-input-number{
        width: 100%;
    }
</style>
<template>
    <div class="stock-calculator">
        <Form :label-width="120">
            <FormItem label="存货选择">
                <StockPicker @select="stockChange">
                    <Button>
                        <span v-if="stock.id">{{stock.uid}} - {{stock.name}}</span>
                        <span class="color-grey" v-else>请选择存货</span>
                    </Button>
                </StockPicker>
            </FormItem>
            <div v-if="stock.id">
                <Row>
                    <i-col span="8">
                        <FormItem label="历史月销量">
                            <div slot="label">
                                历史月销量
                                <Tooltip content="Here is the prompt text">
                                    <Icon></Icon>
                                </Tooltip>
                            </div>
                            {{$util.formatNumber(output_params.out_stock_per_month)}}
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="实时库存数量">{{$util.formatNumber(stock.real_time_qty)}}</FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="在途数量">{{$util.formatNumber(stock.in_transit_qty)}}</FormItem>
                    </i-col>
                </Row>
                <Row>
                    <i-col span="8">
                        <FormItem label="预估未来月销量">
                            <InputNumber v-model="input_params.out_stock_per_month" :max="10000000" :min="1"></InputNumber>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="订多少个月的货?">
                            <InputNumber v-model="input_params.lead_time" :max="12" :min="1"></InputNumber>
                        </FormItem>
                    </i-col>
                </Row>
                <Row>
                    <i-col span="8">
                        <FormItem label="合同流程天数">
                            <InputNumber v-model="input_params.days_of_internal_process" :max="30" :min="1"></InputNumber>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="厂商生产天数">
                            <InputNumber v-model="input_params.days_of_production" :max="180" :min="1"></InputNumber>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="物流天数">
                            <InputNumber v-model="input_params.days_of_logistics" :max="30" :min="1"></InputNumber>
                        </FormItem>
                    </i-col>
                </Row>
                <Divider />
                <Row>
                    <i-col span="8">
                        <FormItem label="建议补货数量">{{$util.formatNumber(output_params.rec_purchase_qty)}}</FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="预估订货日期">
                            <span>{{output_params.order_date}}</span>
                            <span v-if="output_params.reach_order_point_days < 0">( {{-output_params.reach_order_point_days}}天前 )</span>
                            <span v-if="output_params.reach_order_point_days > 0">( {{output_params.reach_order_point_days}}天后 )</span>
                            <span v-if="output_params.reach_order_point_days === 0">( 今天 )</span>
                        </FormItem>
                    </i-col>
                </Row>
                <Row>
                    <i-col span="8">
                        <FormItem label="订货点存货数量">{{$util.formatNumber(output_params.order_point)}}</FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="订货点可售天数">{{$util.formatNumber(output_params.days_order_point_for_sale)}}</FormItem>
                    </i-col>
                </Row>
            </div>
        </Form>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>
<script>
    import StockUtil from '../../../stock/libs/util';
    import StockPicker from '../../../stock/components/stock_picker';

    const default_input_params = {
        days_of_internal_process: 7,
        days_of_production: 30,
        days_of_logistics: 10,
        out_stock_per_month: 0,
        lead_time: 3
    };
    export default {
        components: { StockPicker },
        props: {
            model_id: {
                type: Number,
                default: 0
            }
        },
        data(){
            return {
                loading: false,
                stock: {},
                input_params: this.$util.clone(default_input_params)
            }
        },
        computed: {
            cur_customer(){
                return this.$store.state.cur_customer;
            },
            temp_params() {
                // 预估月销量，从 stock 取值
                const avg_out_stock_per_month = this.stock.avg_out_stock_in_days ? this.stock.avg_out_stock_in_days * 30 : 0;
                if (this.input_params.out_stock_per_month === 0) {
                    this.input_params.out_stock_per_month = avg_out_stock_per_month;
                }
                // 交付周期(月)
                const delivery_cycle = (this.input_params.days_of_internal_process + this.input_params.days_of_production + this.input_params.days_of_logistics) / 30;
                // 交付周期的预计需求量
                const forecast_demand = avg_out_stock_per_month * delivery_cycle;
                // 历史销量 的标准差, 从 stock 取值
                const out_stock_std_dev = parseFloat(this.stock.out_stock_std_dev) || 0;
                // 服务水平
                const service_level = 0.999;
                // 服务系数
                const service_factor = this.normSInv(service_level);
                // 交付周期系数
                const delivery_cycle_factor = math.sqrt(delivery_cycle);
                // 安全库存量
                const safety_stock_qty = out_stock_std_dev * service_factor * delivery_cycle_factor;
                // 再订货点, 即触发订单的库存量
                const order_point = forecast_demand + safety_stock_qty;
                // 系统预计销量（提前订货周期内）
                const auto_forecast_out_stock = avg_out_stock_per_month * this.input_params.lead_time;
                // 用户预计销量（提前订货周期内）
                const user_forecast_out_stock = this.input_params.out_stock_per_month * this.input_params.lead_time;
                // 预计销量和用户估计的差异
                const forecast_difference = avg_out_stock_per_month > 0 ? (avg_out_stock_per_month - this.input_params.out_stock_per_month) / avg_out_stock_per_month : 0;
                return {
                    avg_out_stock_per_month,
                    delivery_cycle,
                    service_level,
                    forecast_demand,
                    service_factor,
                    delivery_cycle_factor,
                    safety_stock_qty,
                    order_point,
                    auto_forecast_out_stock,
                    user_forecast_out_stock,
                    forecast_difference
                }
            },
            output_params() {
                const avg_out_stock_in_days = this.stock.avg_out_stock_in_days || 0;
                const order_point = this.temp_params.order_point;
                const days_order_point_for_sale = avg_out_stock_in_days > 0 ? order_point / this.stock.avg_out_stock_in_days : 99999999;
                const now_time = new Date().getTime();
                const reach_order_point_days = avg_out_stock_in_days > 0 ? parseFloat(math.eval(`(${this.stock.real_time_qty} + ${this.stock.in_transit_qty} - ${order_point}) / ${avg_out_stock_in_days}`).toFixed(0)) : 99999;
                const order_date = this.$util.formatDate( new Date(now_time + reach_order_point_days * 24 * 3600 * 1000) );
                const out_stock_per_month = this.temp_params.avg_out_stock_per_month;
                const real_time_qty = this.stock.real_time_qty || 0;
                const in_transit_qty = this.stock.in_transit_qty || 0;
                const rec_purchase_qty = math.eval(`${this.temp_params.user_forecast_out_stock} - ${real_time_qty} - ${in_transit_qty}`).toFixed(0);
                return {
                    out_stock_per_month,
                    order_point,
                    days_order_point_for_sale,
                    order_date,
                    rec_purchase_qty,
                    reach_order_point_days
                }
            }
        },
        created(){
            this.getStock(this.model_id);
        },
        mounted(){
            //
        },
        methods: {
            getStock(stock_id) {
                if (!stock_id) return;
                this.resetInputParams();
                this.loading = true;
                StockUtil.getStock(stock_id).then((data) => {
                    this.stock = data.stock;
                }).catch((e) => {
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            },
            stockChange(stock) {
                this.getStock(stock.id);
            },
            resetInputParams() {
                this.input_params = this.$util.clone(default_input_params);
            },
            normSInv(p) {
                const a1 = -39.6968302866538, a2 = 220.946098424521, a3 = -275.928510446969;
                const a4 = 138.357751867269, a5 = -30.6647980661472, a6 = 2.50662827745924;
                const b1 = -54.4760987982241, b2 = 161.585836858041, b3 = -155.698979859887;
                const b4 = 66.8013118877197, b5 = -13.2806815528857, c1 = -7.78489400243029E-03;
                const c2 = -0.322396458041136, c3 = -2.40075827716184, c4 = -2.54973253934373;
                const c5 = 4.37466414146497, c6 = 2.93816398269878, d1 = 7.78469570904146E-03;
                const d2 = 0.32246712907004, d3 = 2.445134137143, d4 = 3.75440866190742;
                const p_low = 0.02425, p_high = 1 - p_low;
                let q, r;
                let ret_val;
                if ((p < 0) || (p > 1)) {
                    alert("NormSInv: Argument out of range.");
                    ret_val = 0;
                } else if (p < p_low) {
                    q = Math.sqrt(-2 * Math.log(p));
                    ret_val = (((((c1 * q + c2) * q + c3) * q + c4) * q + c5) * q + c6) / ((((d1 * q + d2) * q + d3) * q + d4) * q + 1);
                } else if (p <= p_high) {
                    q = p - 0.5;
                    r = q * q;
                    ret_val = (((((a1 * r + a2) * r + a3) * r + a4) * r + a5) * r + a6) * q / (((((b1 * r + b2) * r + b3) * r + b4) * r + b5) * r + 1);
                } else {
                    q = Math.sqrt(-2 * Math.log(1 - p));
                    ret_val = -(((((c1 * q + c2) * q + c3) * q + c4) * q + c5) * q + c6) / ((((d1 * q + d2) * q + d3) * q + d4) * q + 1);
                }
                return ret_val;
            },
            test(){
                this.$util.ajax.get('api_url', {
                    params: {
                        //
                    }
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        //成功
                    }else{
                        //失败
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    // always executed
                });
            }
        }
    }
</script>
